import { render } from "./OProjektu.vue?vue&type=template&id=82b18ffe&scoped=true"
const script = {}

import "./OProjektu.vue?vue&type=style&index=0&id=82b18ffe&scoped=true&lang=css"

import exportComponent from "E:\\Faks Projekti\\ssa_sajt\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b18ffe"]])

export default __exports__